import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EntityAsset, Tabs } from '../model/asset.model';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { EntityService } from 'src/app/service/entityService';
import { Entity } from '../model/entity.model';
import { EntityTag } from '../model/entityTag.model';
import { AddEntityAsset } from '../model/addEntityAsset.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { AccessDetails } from '../model/acessDetails.model';
import { OracleEntity } from '../model/oracleEntity.model';
import { EntityAssetService } from '../service/entityAssetService';
import { EntityAssetTag } from '../model/entityAssetTag.model';
import { CommonService } from '../Shared/commonService';
import { HttpResponse, HttpStatusCode } from '@angular/common/http';
import { firstValueFrom, lastValueFrom, Observable, zip,BehaviorSubject, from, concatMap, delay } from 'rxjs';
import { LoadingService } from '../loading.service';
import { MatTabChangeEvent as MatTabChangeEvent } from '@angular/material/tabs';
import DxPopup from 'devextreme/ui/popup';
import { UntypedFormBuilder } from '@angular/forms';
import { environment } from 'src/environments/environment';
import CustomStore from "devextreme/data/custom_store";
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { EntityCategory } from '../model/entityCategory.model';


@Component({
    selector: 'app-manage-assets',
    templateUrl: './manage-assets.component.html',
    styleUrls: ['./manage-assets.component.css'],
    standalone: false
})

export class ManageAssetsComponent implements OnInit {

  store: CustomStore;
  loading$ = this.loader.loading$;
  itemDeleteMode = 'static';
  activeLinkIndex = -1;
  popupVisible : boolean=false;
  tabs: any[];
  pagenumber:number=1;
  pagesize:number=10;
  entityTags: EntityTag[] = [];
  entityTag: EntityTag;
  tempPatchArrayObj: any;
  entityId: number;
  documentassetId:number;
  entityAssetsImages: EntityAsset[];
  addEntityAsset: AddEntityAsset;
  queryString: any;
  urlParams: any;
  entitySourceId: any;
  source: any;
  entityType: any;
  site: any;
  userSite: any;
  appRegion: any;
  nlsLanguage :string="";
  parameters: any;
  accessDetails: AccessDetails;
  accessDetailsObj: AccessDetails;
  entityAddTagBtnFlag: boolean = true;
  hideButton:boolean=false;
  oracleEntity: OracleEntity;
  newEntityTag: string[] = [];

  //#region image component variable declaration
  isVisible = false;
  entityAssetTags: EntityAssetTag[] = [];
  documententityAssetTags: EntityAssetTag[] = [];
  documentAssetTags: EntityAssetTag[] = [];
  entityAssetId: number;
  sourceData: DType[] = [];
  documentSourceData: DType[] = [];
  selectedItem: DType = new DType();
  saveButtonOptions: any;
  positionOf: string;
  tagName: string;
  closeButtonOptions: any;
  entityAssetObjlist: any;
  uploadedFiles: any;
  selectedFilename: any;
  selectedFile: any;
  entityAssetList: EntityAsset[];
  assetAddTagBtnFlag: boolean = true;
  tagAutoFill:boolean=false;
  assetUploadBtnFlag: boolean = false;
  fileName: any;
  testData: SafeUrl;
  selectedTab :string="";
  assetName:string="";
  documentURL:any; 
  nameSortOrder: string = "asc";
  public popup: DxPopup; //#endregion
  public tagOptions = {
    
    onClick: () => { this.popup.show() }
  }
  dataSource: CustomStore//any = [];

  

  readonly displayModes = [{ text: "Display Mode 'full'", value: 'full' }, { text: "Display Mode 'compact'", value: 'compact' }];

  displayMode = 'full';

  showPageSizeSelector = true;

  showInfo = true;

  showNavButtons = true;
reshape='reshape';
  

  constructor( public loader: LoadingService,private router: Router, private cd: ChangeDetectorRef, public dialog: MatDialog, private entityService: EntityService, private commonService: CommonService, private entityAssetService: EntityAssetService,
     private sanitizer: DomSanitizer,private formBuilder :UntypedFormBuilder,private httpClient:HttpClient ) {
    this.tabs = Tabs
    this.popupVisible=false;
    this.downloadFile=this.downloadFile.bind(this);
    this.deleteClicked=this.deleteClicked.bind(this);
    this.TagsClicked=this.TagsClicked.bind(this);
    
  }
  tagsForm = this.formBuilder.group({
   
    name: ''
  });
  
  ngOnInit(): void {
    // Sanitize query string to prevent XSS
    this.queryString = window.location.search;
    // Only allow alphanumeric, dash, underscore, and comma in query string values
    function sanitizeQS(val: string | null): string {
      return val ? val.replace(/[^a-zA-Z0-9-_.,]/g, '') : '';
    }
    this.urlParams = new URLSearchParams(this.queryString);
    this.entitySourceId = sanitizeQS(this.urlParams.get('entitySourceId'));
    this.appRegion = sanitizeQS(this.urlParams.get('appRegion'));
    this.selectedTab = "Images";
    if (this.appRegion == null || this.appRegion === '') {
      this.appRegion = 'AUA';
    }
    this.source = sanitizeQS(this.urlParams.get('source')) + this.appRegion;
    this.entityType = sanitizeQS(this.urlParams.get('entityType'));
    this.site = sanitizeQS(this.urlParams.get('site'));
    this.userSite = sanitizeQS(this.urlParams.get('userSite'));

    if (this.urlParams.get('nlsLanguage') != null) {
      this.nlsLanguage = sanitizeQS(this.urlParams.get('nlsLanguage'));
    }

    this.parameters = 'entityname/' + this.entityType + '/userSite/' + this.userSite;

    this.entityService.GetToken().subscribe((res)=>{
      localStorage.setItem("token",res);
      let entitydetails = this.entityService.getOracleEntity(this.entityType, this.userSite, this.entitySourceId, this.appRegion, this.nlsLanguage);
      zip(entitydetails).subscribe(val => {
        this.oracleEntity=val[0] as OracleEntity;

      // Mock OracleEntity for local testing — uncomment block below and comment above two lines when API is unreachable
      // ((val: any[]) => {
      //   this.oracleEntity = val[0] as OracleEntity;

        if (this.oracleEntity.Status === "S") {
       
      if (this.oracleEntity.AccessLevel) {
        
            if (this.oracleEntity.AccessLevel === 'NO_ACCESS') {
                this.router.navigate(['./custom-error']);
             }
                else {
                  if (this.oracleEntity.AccessLevel === 'FULL_ACCESS') {
                    this.entityAddTagBtnFlag = false;
                    this.hideButton=false;
                    this.assetUploadBtnFlag=false;
                  }
                  else if(this.oracleEntity.AccessLevel === 'READ_ACCESS')
                  {
                    this.hideButton=true;
                    this.assetUploadBtnFlag=true;
                  }
                  if (this.entitySourceId != null && this.source != null && this.entityType != null) {
                    this.entityService.getEntityCategory(this.source, this.entityType).subscribe((res: EntityCategory) => {
                      if(res.DataTypeId==2)
                      {
                        this.router.navigate(['./not-found']);
                      }
                      else
                      {
                        this.entityService.getEntitySourceAsset(this.entitySourceId, this.source, this.entityType, this.site).subscribe((res: Entity) => {
                          this.entityTags = res.entityTags;
                          this.entityId = res.entityId;
                         
                          if (res.entityAssets) {
                            this.entityAssetsImages = res.entityAssets.filter(x => x.typeId == 1);
                          }
                          this.loadImagesData();
                     
                        },
                          (err: any) => {
                            if (this.oracleEntity) {
                              var entityTagListObj = this.oracleEntity.DescriptionToken.split('~');
                              if (entityTagListObj) {
                                if (entityTagListObj.length > 3) {
                                  entityTagListObj = entityTagListObj.slice(0, 3);
                                }
                                this.newEntityTag = entityTagListObj;
                              }
                            }
                            this.addEntityAsset = { sourceEntityId: this.entitySourceId, source: this.source, entityType: this.entityType, site: this.site, entityTags: this.newEntityTag };
                            this.entityService.addEntity(this.addEntityAsset).subscribe((res: Entity) => {
                              this.entityTags = res.entityTags;
                              this.entityId = res.entityId;
                             
                              if (res.entityAssets) {
                                this.entityAssetsImages = res.entityAssets.filter(x => x.typeId == 1);
                              }
                              this.loadImagesData();
                          
                            })
                          })
                        }
                      }
                      ,
                      (err: any) => {
                        this.router.navigate(['./not-found']);
                      }

                    )
                  }
                }
              }
              else {
                this.router.navigate(['./custom-error']);
              }
            }
               else {
            this.router.navigate(['./not-found']);
          }
      }); // End of getOracleEntity subscribe
      // })([{ Status: 'S', ProcessMessage: '', Description: 'Mock Oracle Entity', DescriptionToken: 'Mock~Token~Value', AccessLevel: 'FULL_ACCESS' }]); // End of mock OracleEntity IIFE
    }); // End of GetToken subscribe
  }
        
      

        

  onChange(event: MatTabChangeEvent) {
    this.selectedTab = event.tab.textLabel;
   
      
    
    if(this.selectedTab==="Documents")
      {
         this.loadDocumentsData();

        }
  }


  GetFileSize(e:any)
  {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let l = 0, n = parseInt(e.size, 10) || 0;

      while(n >= 1024 && ++l){
          n = n/1024;
      }
  
    return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);

  }


  calculateSummary(options: any) {
    
    if(options.name == "customSummary1") {
      options.totalValue=10;
    }
  }


  GetDocType(e:any) {

    var doctype="";
  
    switch (e) {
      case "docx":
        doctype="data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
          break;
      case "pdf":
        doctype="data:application/pdf;base64,";
          break;
      case "mp4":
       doctype="data:video/mp4;base64,";
        break;
     
    }
return doctype;

}

  GetIconURL(e:any) {

            var str=e.name.split('.');
            var docExtension=str[1];
            var docIconUrl="";
          
            switch (docExtension) {
              case "docx":
                docIconUrl="../assets/images/docx_icon.png";
                  break;

              case "pdf":
                docIconUrl="../assets/images/pdf-icon.jpg";
                  break;

              case "xlsx":
                docIconUrl="../assets/images/excel-icon.png";
                  break;

              case "mp4":
                docIconUrl="../assets/images/video-image.png";
                break;

              default:
                docIconUrl="../assets/images/other-doc.png";
                  break;
            }
    return docIconUrl;

  }

  loadDocumentsData() {
    let that=this;
    let sortorder:string="asc";
    let sortfield:string="name";
    this.dataSource = new CustomStore({
      key: 'id',
    
      load(loadOptions: any) { 
      
        that.pagenumber=Math.floor(loadOptions.skip / loadOptions.take) + 1
        that.pagesize=loadOptions.take;
        if(loadOptions.sort!=null)
        {
        if(loadOptions.sort[0].desc)
        {
          sortorder="desc";

        }
        else
        {
          sortorder="asc";
        }
        sortfield=loadOptions.sort[0].selector;
      }
       return  that.entityAssetService.getEntityAssetByEntityId(that.entityId,that.pagenumber,that.pagesize,sortfield,sortorder).toPromise().then((res) => {
        
        return {  
          data: res.entityAsset,  
          totalCount: res.totalCount
          
      } 
          });
         
      }});
    }
   

  onSubmit(): void {
    
    const data = { "EntityAssetTagId": "0", "EntityAssetId": this.documentassetId, "TagName": this.tagsForm['value'].name };
    this.entityAssetService.UpdateEntityAssetTag(data).subscribe((res: EntityAssetTag) => {
     
          this.documentAssetTags.push(res);
      });
   
    this.tagsForm.reset();
    
  }



  //#region Image component code goes here
  loadImagesData() {
    this.entityAssetObjlist = this.entityAssetsImages;
    if (this.entityAssetObjlist) {
      if (this.entityAssetObjlist.length > 0) {
        
        for (let j = 0; j < this.entityAssetObjlist.length; j++) {
          this.entityService.getSingleImageAsset(this.entityAssetObjlist[j].sampleUrl,false).then((res: any) => {
            var Item: DType = new DType();
            Item.originalUrl = this.entityAssetObjlist[j].originalUrl;
            
            Item.CreatedBy = this.entityAssetObjlist[j].createdBy;
            this.validateAndSetImageUrl(res,Item);
            if (this.entityAssetObjlist[j].createdDate) {
              const date = this.entityAssetObjlist[j].createdDate;
              Item.CreatedDate = new Date(date);
            }
            Item.entityAssetId = this.entityAssetObjlist[j].id;
            Item.name=this.entityAssetObjlist[j].name;
            
            this.sourceData.push(Item);
            if (this.sourceData.length == 1) {
              this.selectedItem = this.sourceData[0];
              this.displayData(this.selectedItem, true);
            }
          })
            .catch((error) => {
            });
        }
      }
    }
    
    if (this.oracleEntity) {
      if (this.oracleEntity.AccessLevel === 'FULL_ACCESS' || this.oracleEntity.AccessLevel === 'UPDATE_ACCESS') {
        if (this.entityAssetObjlist) {
          if (this.entityAssetObjlist.length > 0) {
            this.assetAddTagBtnFlag = false;
            this.assetUploadBtnFlag = false;
            this.hideButton=false;
          }
         
          
        }
      }
    }
  }


async TagsClicked (e:any)
{
  if (e.row.data.id) {
    this.documentAssetTags=[];
    this.documentassetId=e.row.key;
    (await this.entityAssetService.getEntityAsset(e.row.data.id).subscribe((res: EntityAsset) => {
      this.documentAssetTags=res.entityAssetTags;
  
   this.popupVisible=true;
  }));
  
}
}

async downloadFile(e: any)
 {
  var str=e.row.data.name.split('.');
  var docExtension=str[1];
  
  var Item: DType = new DType();
   var sourceData= await this.entityService.getSingleImageAsset(e.row.data.originalUrl,false);
  Item.sourceData= sourceData?.sourceData;
   
  const byteArray= new Uint8Array(
    atob(Item.sourceData).split('').map((char)=>char.charCodeAt(0))
  );

   const file= new Blob([byteArray],{type:this.GetDocType(docExtension)});
   const fileURL= URL.createObjectURL(file);
   // Sanitize fileName to prevent XSS
   let fileName = String(e.row.data.name).replace(/[^a-zA-Z0-9._-]/g, '_');
   let link = document.createElement('a');
   link.download = fileName;
   link.target = "_blank";
   link.rel = "noopener noreferrer";
   // Only allow blob: URLs for download
   if (typeof fileURL === 'string' && /^blob:[a-zA-Z0-9\-]+:.+/.test(fileURL)) {
     link.href = fileURL;
     document.body.appendChild(link);
     // Remove from DOM before navigation to prevent any possible script execution
     document.body.removeChild(link);
     link.click();
   } else {
     console.error('Unsafe file URL detected, download aborted.');
   }
 
 }

  deleteClicked (e:any) {
  
    this.tempPatchArrayObj = [];
    var patchArrayObj = [];
    this.tempPatchArrayObj.push(this.commonService.createPatchArray("Id", e.row.data.id));
    this.tempPatchArrayObj.push(this.commonService.createPatchArray("Active", 0));
    for (var i = 0; i < this.tempPatchArrayObj.length; i++) {   //pushing the 0th
      patchArrayObj.push(this.tempPatchArrayObj[i][0]);
    }
    this.entityAssetService.getPatchEntityAsset(e.row.data.id, patchArrayObj, this.appRegion).subscribe((res: EntityAsset) => {
      
      this.dataSource.push([{ type: "remove", key: e.row.data.id }]);
      
    });
  
}
  loadEntityImageAsset(entity: any) {

    this.isVisible = true;
    this.entityAssetId = entity.entityAssetId;
  
    if (entity.entityAssetId) {
      this.entityAssetService.getEntityAsset(entity.entityAssetId).subscribe((res: EntityAsset) => {
        this.entityAssetTags=[];
        this.entityAssetTags=res.entityAssetTags;
      });
    }
    
  }

   displayData(entity: any,requireCompressedImage:boolean) {
    if (!this.isDeleteClicked) {
      this.entityService.getSingleImageAsset(entity.originalUrl,requireCompressedImage).then((res :any) => {
        var Item: DType = new DType();
        Item.Originalsize= this.formatBytes(res.originalsize);
        Item.Compressedsize= this.formatBytes(res.compressedsize);

        const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
        const mimeType = 'image/png';
        const safeBase64 = typeof res.sourceData === 'string' && base64Regex.test(res.sourceData);

        if (safeBase64) {
          const rawDataUrl = `data:${mimeType};base64,${res.sourceData}`;
          // Use compressImage to render a canvas-resized version client-side for faster display
          this.compressImage(rawDataUrl, 1000, 1000).then((compressedDataUrl: any) => {
            Item.imgUrl = this.sanitizer.bypassSecurityTrustResourceUrl(compressedDataUrl);
            entity.imgUrl = Item.imgUrl;
            entity.Originalsize = Item.Originalsize;
            entity.Compressedsize = Item.Compressedsize;
            this.selectedItem = entity;
            this.loadEntityImageAsset(entity);
          }).catch(() => {
            // Fallback to direct display if canvas compression fails
            this.validateAndSetImageUrl(res, Item);
            entity.imgUrl = Item.imgUrl;
            entity.Originalsize = Item.Originalsize;
            entity.Compressedsize = Item.Compressedsize;
            this.selectedItem = entity;
            this.loadEntityImageAsset(entity);
          });
        } else {
          Item.imgUrl = null;
          console.error('Unsafe image data detected or invalid MIME type');
          entity.imgUrl = null;
          this.selectedItem = entity;
          this.loadEntityImageAsset(entity);
        }
      });
    }
  }
 

  addDocumentTag(entityasset:any){
    const dialog = this.dialog.open(ConfirmationComponent, {
      width: '400px',
      data: {
        isAddAssetTag: true,
        buttonText: {
          ok: 'Add Tag',
          cancel: 'Cancel'
        }
      }
    });
    dialog.afterClosed().subscribe(result => {
      if (result !== false) {
        const data = { "EntityAssetTagId": "0", "EntityAssetId": entityasset.entityAssetId, "TagName": result };
        this.entityAssetService.UpdateEntityAssetTag(data).subscribe((res: EntityAssetTag) => {
         
          for (var value of this.documentSourceData) {
            if(value.entityAssetId==res.entityAssetId)
            {
              value.entityAssetsTags.push(res);
            }
          }
          
     
        });
      }
    });


  }

  addTag() {
    const dialog = this.dialog.open(ConfirmationComponent, {
      width: '400px',
      data: {
        isAddAssetTag: true,
        buttonText: {
          ok: 'Add Tag',
          cancel: 'Cancel'
        }
      }
    });



    dialog.afterClosed().subscribe(result => {
      if (result !== false) {
        const data = { "EntityAssetTagId": "0", "EntityAssetId": this.entityAssetId, "TagName": result };
        this.entityAssetService.UpdateEntityAssetTag(data).subscribe((res: EntityAssetTag) => {
         
          this.entityAssetTags.push(res);
         
        });
      }
    });
  }

  removeDocumentTag(Tag: any)
  {
    this.entityAssetService.DeleteEntityAssetTag(Tag.entityAssetTagId).subscribe((res: EntityAssetTag) => {
      const index = this.documentAssetTags.indexOf(Tag);
      if (index >= 0) {
        this.documentAssetTags.splice(index, 1);
      }
    });

  }

  remove(Tag: any): void {
    const dialog = this.dialog.open(ConfirmationComponent, {
      width: '400px',
      data: {
        isAddAssetTag: false,
        message: 'Are you sure want to delete?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    })
    dialog.afterClosed().subscribe(result => {
      if (result !== false) {
        this.entityAssetService.DeleteEntityAssetTag(Tag.entityAssetTagId).subscribe((res: EntityAssetTag) => {
          const index = this.entityAssetTags.indexOf(Tag);
          if (index >= 0) {
            this.entityAssetTags.splice(index, 1);
          }
        });
      }
    })
  }

  isDeleteClicked: boolean;
  deleteAsset(item: any) {
    if (!this.assetAddTagBtnFlag) {
      this.isDeleteClicked = true;
      this.tempPatchArrayObj = [];
      var patchArrayObj = [];
      this.tempPatchArrayObj.push(this.commonService.createPatchArray("Id", item.entityAssetId));
      this.tempPatchArrayObj.push(this.commonService.createPatchArray("Active", 0));
      for (var i = 0; i < this.tempPatchArrayObj.length; i++) {   //pushing the 0th
        patchArrayObj.push(this.tempPatchArrayObj[i][0]);
      }
      this.entityAssetService.getPatchEntityAsset(item.entityAssetId, patchArrayObj, this.appRegion).subscribe((res: EntityAsset) => {
        const index = this.sourceData.indexOf(item);
        if (index >= 0) {
          this.sourceData.splice(index, 1);
        }
        this.isDeleteClicked = false;

        this.selectedItem = this.sourceData[0];
        if (this.sourceData[0]) {
          this.entityAssetId = this.sourceData[0].entityAssetId;
          if (this.entityAssetId) {
            this.entityAssetService.getEntityAsset(this.entityAssetId).subscribe((res: EntityAsset) => {
              this.entityAssetTags = res.entityAssetTags;
            });
          }
          else {
            this.entityAssetTags = [];
            this.sourceData = [];
            this.selectedItem = new DType;
            this.assetAddTagBtnFlag = true;
          }
        }
        else {
          this.entityAssetTags = [];
          this.sourceData = [];
          this.selectedItem = new DType;
          this.assetAddTagBtnFlag = true;
        }
      });
    }
  }

   formatBytes(bytes: any) {
    var marker = 1024; // Change to 1000 if required
    var decimal = 3; // Change as required
    var kiloBytes = marker; // One Kilobyte is 1024 bytes
    var megaBytes = marker * marker; // One MB is 1024 KB
    var gigaBytes = marker * marker * marker; // One GB is 1024 MB
  
    // return bytes if less than a KB
    if(bytes < kiloBytes) return bytes + " Bytes";
    // return KB if less than a MB
    else if(bytes < megaBytes) return(bytes / kiloBytes).toFixed(decimal) + " KB";
    // return MB if less than a GB
    else if(bytes < gigaBytes) return(bytes / megaBytes).toFixed(decimal) + " MB";
    // return GB if less than a TB
    else return(bytes / gigaBytes).toFixed(decimal) + " GB";
}
   
 BytesLength(x: any){
  const units = ['bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let l = 0, n = parseInt(x, 10) || 0;
  while(n >= 1024 && ++l){
      n = n/1024;
  }
  return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}
 

 compressImage(src: any, newX: any, newY: any) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');
      elem.width = newX;
      elem.height = newY;
      const ctx = elem.getContext('2d');
      if(ctx!=null)
      {
      ctx.drawImage(img, 0, 0, newX, newY);
      const data = ctx.canvas.toDataURL();
      res(data);
      }
    }
    img.onerror = error => rej(error);
  })
}

resizeImage(imageURL: any): Promise<any> {
  return new Promise((resolve) => {
    var image = new Image();
    image.onload = function () {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      if (ctx != null) {
        ctx.drawImage(image, 0, 0, 1000, 1000);  // <-- draw the right image!
      }
      var data = canvas.toDataURL('image/png', 0.5);
      resolve(data);   // <-- call it here!
    };
    image.src = imageURL;
  });
}

dataURLtoFile(dataURL: string, filename: string) {
  const arr = dataURL.split(',');
  const mime =  arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      let sizeInBytes: number = file.size;
      var str=file.name.split('.');
      var docExtension=str[1];
      var inValidFormats = ['exe','bat','com','inf','ipa','osx','pif','run','wsh','sql'];
      
      if(sizeInBytes>environment.FileUploadSize)
      {
        this.dialog.open(ConfirmationComponent, {
          width: '400px',
          data: {
          
        buttonText: {
          ok: 'OK',
          cancel: 'Cancel'
        },
            
            message: 'Maximum of 20 MB file upload is allowed',
          }
        });

      }
      else if(inValidFormats.find(x=>x===docExtension))
      {
        this.dialog.open(ConfirmationComponent, {
          width: '400px',
          data: {
          
        buttonText: {
          ok: 'OK',
          cancel: 'Cancel'
        },
            
            message: 'File type with extension '+docExtension+' not allowed',
          }
        });

      }
      else
      {

        
      this.fileName = file.name;

      if(this.selectedTab==="Documents")
        {
          const docFormData = new FormData();
          docFormData.append("file", file);
          this.entityService.uploadEntityAsset(this.entityId, docFormData, this.appRegion).subscribe((res: EntityAsset) => {
            var Item: DType = new DType();
            Item.entityAssetId = res.id;
           
            if(res.typeId==2 || res.typeId==3)
            {
             this.dataSource.push([{ type: "insert", data: res, index: -1 }]);
              
            }
          
         
            if (!this.entityAssetId) {
              this.entityAssetId = this.selectedItem.entityAssetId;
            }
    
            const t = { "EntityAssetTagId": "0", "EntityAssetId": Item.entityAssetId, "TagName": this.entitySourceId };
            this.entityAssetService.UpdateEntityAssetTag(t).subscribe((res: EntityAssetTag) => { //add entity source id as image asset tag
            });
          },
           (error: Response) => {  
             if(error.status === HttpStatusCode.RangeNotSatisfiable)  
              this.dialog.open(ConfirmationComponent, {
               width: '400px',
               data: {
               
             buttonText: {
               ok: 'OK',
               cancel: 'Cancel'
             },
                 isAddAssetTag: false,
                 isAddTag:false,
                 message: 'To add additional images please delete some of the existing images',
               }
             });
             if(error.status === HttpStatusCode.BadRequest || error.status === HttpStatusCode.NotFound
              || error.status === HttpStatusCode.UnprocessableEntity)  
              this.dialog.open(ConfirmationComponent, {
               width: '400px',
               data: {
               
             buttonText: {
               ok: 'OK',
               cancel: 'Cancel'
             },
                 isAddAssetTag: false,
                 isAddTag:false,
                 message: 'There was a problem uploading, please contact an administrator and try again later',
               }
             });
            } );
          return; // Documents handled — do not fall through to image upload path
            };


        

      // Image upload: send original file only — API handles sample/thumbnail generation
      const imageFormData = new FormData();
      imageFormData.append("file", file);

      this.entityService.uploadEntityAsset(this.entityId, imageFormData, this.appRegion).subscribe((res: EntityAsset) => {
        var Item: DType = new DType();
        Item.entityAssetId = res.id;

        if(res.typeId==1)
        {
          this.validateAndSetImageUrl(res, Item);
          Item.originalUrl = res.originalUrl;
          Item.CreatedBy = res.createdBy;
          Item.CreatedDate = new Date(res.createdDate.toString());
          Item.Originalsize= this.formatBytes(res.originalsize);
          Item.Compressedsize= this.formatBytes(res.compressedsize);
          Item.name=res.name;
          this.sourceData.push(Item);
          this.selectedItem = Item;
          if (this.oracleEntity.AccessLevel === 'FULL_ACCESS' || this.oracleEntity.AccessLevel === 'UPDATE_ACCESS') {
            this.assetAddTagBtnFlag = false;
          }
        }

        // Always update to the newly uploaded asset so addTag() targets the correct ID.
        this.entityAssetId = Item.entityAssetId;

        const t = { "EntityAssetTagId": "0", "EntityAssetId": Item.entityAssetId, "TagName": this.entitySourceId };
        this.entityAssetService.UpdateEntityAssetTag(t).subscribe((res: EntityAssetTag) => {
          if (Item.entityAssetId) {
            this.entityAssetService.getEntityAsset(Item.entityAssetId).subscribe((assetRes: EntityAsset) => {
              this.entityAssetTags = assetRes.entityAssetTags;
              this.cd.detectChanges();
              this.displayData(Item, true);
            });
          }
        });
      },
       (error: Response) => {
         if(error.status === HttpStatusCode.RangeNotSatisfiable)
          this.dialog.open(ConfirmationComponent, {
           width: '400px',
           data: {
             buttonText: { ok: 'OK', cancel: 'Cancel' },
             isAddAssetTag: false,
             isAddTag:false,
             message: 'To add additional images please delete some of the existing images',
           }
         });
         if(error.status === HttpStatusCode.BadRequest || error.status === HttpStatusCode.NotFound
          || error.status === HttpStatusCode.UnprocessableEntity)
          this.dialog.open(ConfirmationComponent, {
           width: '400px',
           data: {
             buttonText: { ok: 'OK', cancel: 'Cancel' },
             isAddAssetTag: false,
             isAddTag:false,
             message: 'There was a problem uploading, please contact an administrator and try again later',
           }
         });
        });
     
    }
  }
  }

  private validateAndSetImageUrl(res: any, Item: DType) {
    const mimeType = 'image/png';
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;


    const allowedMimeTypes = ['image/png', 'image/jpeg'];
    const safeMimeType = allowedMimeTypes.includes(mimeType);
    const safeBase64 = typeof res.sourceData === 'string' && base64Regex.test(res.sourceData);
    if (safeMimeType && safeBase64) {
      const dataUrl = `data:${mimeType};base64,${res.sourceData}`;
      Item.imgUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
    } else {
      Item.imgUrl = null;
      console.error('Unsafe image data detected or invalid MIME type');
    }
  }
  //#endregion
}

export class DType {
  IconUrl:SafeUrl;
  imgUrl: SafeUrl;
  CreatedBy: any;
  CreatedDate: Date;
  entityAssetId: any;
  originalUrl: any;
  name: any;
  sourceData : any;
  entityAssetsTags: EntityAssetTag[];
  doctype:any;
  docextension:any;
  size: any;
  Originalsize? :any;
  Compressedsize? :any; 
}


